import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';

export interface SerasaModal {
  mensagemPendencia: any;
  objSerasa: any;
  proposalID: any;
  clientID: any;
}

@Component({
  selector: 'app-cc-serasa-modal-lc',
  templateUrl: './cc-serasa-modal-lc.component.html',
  styleUrls: ['./cc-serasa-modal-lc.component.scss'],
  providers: [LimitFlowProposalService]
})

export class CcSerasaModalLCComponent extends DialogComponent<SerasaModal, number> implements SerasaModal {

  mensagemPendencia: any;
  objSerasa: any;
  proposalID: any;
  clientID: any;

  constructor(dialogService: DialogService, private limitFlowProposalService: LimitFlowProposalService, private flashMessagesService: FlashMessagesService, private router: Router) {
    super(dialogService);
  }

  continue() {
    // we set dialog result as true on click on prosseguir button, 
    // then we can get dialog result from caller code 
    this.result = 1;
    this.close();
  }

  cancelProposal() {
    this.result = 2;
    this.close();
  }
  
  confirm() {
    this.result = 0;
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/cc-serasa-modal-lc/cc-serasa-modal-lc.component.ts